import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const skillMap = api(async function skillMap({ id }) {
    return query(
        gql`
            query GetSkillMap($id: String!) {
                skillMap(id: $id) {
                    id
                    name
                    description
                    trades
                    isArchived
                    created
                    modified
                }
            }
        `,
        { id },
        { returns: "skillMap" }
    )
})
